var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0254 3H10.0254C6.1594 3 3.02539 6.13401 3.02539 10V22C3.02539 25.866 6.1594 29 10.0254 29H22.0254C25.8914 29 29.0254 25.866 29.0254 22V10C29.0254 6.13401 25.8914 3 22.0254 3ZM10.0254 0C4.50254 0 0.0253906 4.47715 0.0253906 10V22C0.0253906 27.5228 4.50254 32 10.0254 32H22.0254C27.5482 32 32.0254 27.5228 32.0254 22V10C32.0254 4.47715 27.5482 0 22.0254 0H10.0254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.8ed017f4927ff97f7a50a76bb57aaf85.svg";
export { ForwardRef as ReactComponent };